import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { v4 as uuidv4 } from 'uuid';

import './index.scss';

const SkeletonConditions = () => {
  const renderSkeletonColumn = (rows: number) => (
    <div className="skeleton__conditions__column">
      {[...Array(rows)].map(() => (
        <div className="skeleton__conditions__item" key={uuidv4()}>
          <Skeleton height={60} />
        </div>
      ))}
    </div>
  );
  return (
    <div className="skeleton__conditions skeleton__conditions__bb">
      {renderSkeletonColumn(4)}
      {renderSkeletonColumn(4)}
    </div>
  );
};

export default SkeletonConditions;
